const Restart = {
    restart: () => {
        window.location = window.location.origin;
    }
};

export default Restart;